import * as React from "react";
import { Field } from "formik";
import { Select } from "antd";
import { useFindAllLocations } from "@njoy/controller";

import { InputField } from "../../shared/InputField";
import { SelectField } from "../../shared/SelectField";
import { useBrand } from "../../../hooks/useBrand";
import { BrandName } from "../../../components/shared/BrandName";

const { Option } = Select;

export const Page1: React.FC = () => {
  const { appName } = useBrand();
  const { locations = [], loading } = useFindAllLocations();

  const refactoredLocations = locations
    ? locations
        .slice()
        .sort((a: any, b: any) => a.city.localeCompare(b.city))
        .map((l: any) => ({
          id: l.id,
          label: l.city,
        }))
    : [];

  return (
    <>
      <label className="text-[#CECECF]" htmlFor="firstname">
        First Name{" "}
        <span className="text-[10px] pl-1 text-[#998CA1]">
          (As it appears on your government-issued ID)
        </span>
      </label>
      <Field
        name="firstname"
        placeholder="Enter First Name"
        component={InputField}
      />

      <label className="text-[#CECECF]" htmlFor="lastname">
        Last Name{" "}
        <span className="text-[10px] pl-1 text-[#998CA1]">
          (As it appears on your government-issued ID)
        </span>
      </label>
      <Field
        name="lastname"
        placeholder="Enter Last Name"
        component={InputField}
      />

      <label className="text-[#CECECF]" htmlFor="username">
        <BrandName /> Username
      </label>
      <Field
        name="username"
        placeholder={`Enter ${appName} Username`}
        component={InputField}
      />

      <label className="text-[#CECECF]" htmlFor="locationId">
        Select Your Location
      </label>
      <Field name="locationId" component={SelectField}>
        <Option value="" disabled>
          Select location
        </Option>
        {loading ? (
          <Option value="" disabled>
            Loading...
          </Option>
        ) : refactoredLocations ? (
          refactoredLocations.map((c: any) => (
            <Option key={c.id} value={c.id}>
              {c.label}
            </Option>
          ))
        ) : (
          <></>
        )}
      </Field>

      <label className="text-[#CECECF]" htmlFor="referralCode">
        Referral Code{" "}
        <span className="text-[10px] pl-1 text-[#998CA1]">
          (Optional)
        </span>
      </label>
      <Field
        name="referralCode"
        placeholder="Enter Referral Code"
        component={InputField}
      />
    </>
  );
};
